import React, { useRef, useState, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Spinner, Alert } from 'reactstrap';
import Select from "react-select";
import FractionSlider from '../Common/FractionSlider';
import VehicleDamageForm from '../Common/VehicleDamageForm';
import useRecepcionVehiculoPorId from '../Hooks/useRecepcionVehiculoPorId';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';
import { RECEPCION_VEHICULO_PDF } from '../../helpers/url_helper';

const ModalLeerRecepcionVehiculo = ({ isOpen, toggle, idRecepcion }) => {
    const tenantId = useSelector((state) => state.Context.tenantId);
    const apiBackendClient = new ApiBackendClient();

    // obtener datos completos del backend
    const { recepcion: recepcionFromApi, loading: loadingApi, error: errorApi } = useRecepcionVehiculoPorId(idRecepcion);

    // Estados para el PDF
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [errorPdf, setErrorPdf] = useState(null);

    // Transformar inventario array a objeto
    const inventarioObj = useMemo(() => {
        if (!recepcionFromApi?.inventario) return {};
        return recepcionFromApi.inventario.reduce((acc, item) => {
            acc[item.elemento] = item.estaPresente;
            return acc;
        }, {});
    }, [recepcionFromApi?.inventario]);

    const handleDownloadPdf = async () => {
        setLoadingPdf(true);
        setErrorPdf(null);
        try {
            const response = await apiBackendClient.get(`${RECEPCION_VEHICULO_PDF}/${idRecepcion}?tenantId=${tenantId}`);
            console.log('response handleDownloadPdf', response)
            if (response.pdf_base64) {
                // Convert base64 to blob and download
                const byteCharacters = atob(response.pdf_base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });

                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `recepcion_${recepcionFromApi?.patent || recepcionFromApi?.patente || idRecepcion}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } else {
                setErrorPdf('PDF no encontrado o error al descargar.');
            }
        } catch (error) {
            console.error('Error downloading PDF:', error);
            setErrorPdf('Error al descargar el PDF.');
        } finally {
            setLoadingPdf(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <i className="ri-eye-line me-2"></i>
                Consulta Recepción de Vehículo - {recepcionFromApi?.patent || recepcionFromApi?.patente || 'Cargando...'}
            </ModalHeader>
            <ModalBody>
                <Form>
                    {loadingApi ? (
                        <div className="text-center py-4">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Cargando datos de la recepción...</p>
                        </div>
                    ) : errorApi ? (
                        <div className="alert alert-danger">
                            <i className="ri-error-warning-line me-2"></i>
                            Error al cargar los datos: {errorApi}
                        </div>
                    ) : recepcionFromApi ? (
                        <>
                            {console.log('recepcionFromApi.combustible:', recepcionFromApi?.combustible)}

                            {!false ? (
                                <>
                                    <div className="d-flex align-items-center my-2">
                                        <div className="flex-grow-1 border-top"></div>
                                        <span className="mx-3 text-muted fw-bold">Datos de contacto</span>
                                        <div className="flex-grow-1 border-top"></div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <FormGroup>
                                                <Label for="contacto">Nombre contacto</Label>
                                                <Input
                                                    type="text"
                                                    id="contacto"
                                                    name="contacto"
                                                    value={recepcionFromApi.contacto || recepcionFromApi.clipro || 'N/A'}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-6">
                                            <FormGroup>
                                                <Label for="email">Email</Label>
                                                <Input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    value={recepcionFromApi.correocontacto || 'N/A'}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="col-6">
                                            <FormGroup>
                                                <Label for="telefono">Teléfono</Label>
                                                <Input
                                                    type="text"
                                                    id="telefono"
                                                    name="telefono"
                                                    value={recepcionFromApi.fonocontacto || 'N/A'}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>

                                </>) : <></>}

                            <div className="d-flex align-items-center my-2">
                                <div className="flex-grow-1 border-top"></div>
                                <span className="mx-3 text-muted fw-bold">Vehículo</span>
                                <div className="flex-grow-1 border-top"></div>
                            </div>
                            <div className="row  align-items-end">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="patente">Patente</Label>
                                        <Input
                                            type="text"
                                            id="patente"
                                            name="patente"
                                            value={recepcionFromApi.patent || recepcionFromApi.patente || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="odometro">Odómetro</Label>
                                        <Input
                                            type="number"
                                            id="odometro"
                                            name="odometro"
                                            value={recepcionFromApi.odometro || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row  align-items-end">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="emisora_radio">Emisora radio</Label>
                                        <Input
                                            type="text"
                                            id="emisora_radio"
                                            name="emisora_radio"
                                            value={recepcionFromApi.emisora_radio || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="servicio">Servicio</Label>
                                        <Input
                                            type="number"
                                            id="servicio"
                                            name="servicio"
                                            value={recepcionFromApi.servicio || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="nivel_combustible">Combustible</Label>
                                        <FractionSlider
                                            value={recepcionFromApi.combustible || 0}
                                            disabled={true}
                                            onChange={() => { }}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="tipo_trabajo">Tipo Trabajo</Label>
                                        <Input
                                            type="text"
                                            id="tipo_trabajo"
                                            name="tipo_trabajo"
                                            value={recepcionFromApi.cod_tiporeparacion || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <FormGroup>
                                        <Label for="solicitud_cliente">Solicitud cliente</Label>
                                        <Input
                                            type="textarea"
                                            id="solicitud_cliente"
                                            name="solicitud_cliente"
                                            value={recepcionFromApi.reparacion_requerida || 'N/A'}
                                            disabled
                                            rows="3"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <Label for="sin_inventario">Sin inventario</Label>
                                </div>
                                <div className="col-6">
                                    <Input
                                        type="checkbox"
                                        id="sin_inventario"
                                        name="sin_inventario"
                                        checked={recepcionFromApi.sin_inventario}
                                        disabled
                                    />
                                </div>
                            </div>

                            {/* Inventario */}
                            {recepcionFromApi.inventario && !recepcionFromApi.sin_inventario && (
                                <>
                                    <div className="d-flex align-items-center my-2">
                                        <div className="flex-grow-1 border-top"></div>
                                        <span className="mx-3 text-muted fw-bold">Inventario</span>
                                        <div className="flex-grow-1 border-top"></div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-6">
                                            <Label for="plumillas">Plumillas</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="plumillas"
                                                name="plumillas"
                                                checked={inventarioObj.plumillas}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="radio">Radio</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="radio"
                                                name="radio"
                                                checked={inventarioObj.radio}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="panel_radio">Panel radio</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="panel_radio"
                                                name="panel_radio"
                                                checked={inventarioObj.panel_radio}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="herramientas">Herramientas</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="herramientas"
                                                name="herramientas"
                                                checked={inventarioObj.herramientas}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="gata">Gata</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="gata"
                                                name="gata"
                                                checked={inventarioObj.gata}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="extintor">Extintor</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="extintor"
                                                name="extintor"
                                                checked={inventarioObj.extintor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="botiquin">Botiquín</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="botiquin"
                                                name="botiquin"
                                                checked={inventarioObj.botiquin}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="permiso_circulacion">Permiso circulación</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="permiso_circulacion"
                                                name="permiso_circulacion"
                                                checked={inventarioObj.permiso_circulacion}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="libro_garantia">Libro garantía</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="libro_garantia"
                                                name="libro_garantia"
                                                checked={inventarioObj.libro_garantia}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="encendedor">Encendedor</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="encendedor"
                                                name="encendedor"
                                                checked={inventarioObj.encendedor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="accesorios">Accesorios</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="accesorios"
                                                name="accesorios"
                                                checked={inventarioObj.accesorios}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="neumatico_repuesto">Neumático repuesto</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="neumatico_repuesto"
                                                name="neumatico_repuesto"
                                                checked={inventarioObj.neumatico_repuesto}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="tapa_rueda">Tapa rueda</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="tapa_rueda"
                                                name="tapa_rueda"
                                                checked={inventarioObj.tapa_rueda}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <Label for="cubre_pisos">Cubre pisos</Label>
                                        </div>
                                        <div className="col-6">
                                            <Input
                                                type="checkbox"
                                                id="cubre_pisos"
                                                name="cubre_pisos"
                                                checked={inventarioObj.cubre_pisos}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    {recepcionFromApi.obs_inventario && (
                                        <div className="row">
                                            <FormGroup>
                                                <Label>Observaciones de inventario</Label>
                                                <div className="form-control-plaintext" style={{ whiteSpace: 'pre-wrap' }}>{recepcionFromApi.obs_inventario}</div>
                                            </FormGroup>
                                        </div>
                                    )}
                                </>
                            )}

                            <div className="row">
                                <div className="col-6">
                                    <Label for="sin_danos">Sin daños aparentes</Label>
                                </div>
                                <div className="col-6">
                                    <Input
                                        type="checkbox"
                                        id="sin_danos"
                                        name="sin_danos"
                                        checked={recepcionFromApi.sindanos_chk}
                                        disabled
                                    />
                                </div>
                            </div>

                            {/* Daños */}
                            {!recepcionFromApi.sindanos_chk ? <>
                                <div className="d-flex align-items-center my-2">
                                    <div className="flex-grow-1 border-top"></div>
                                    <span className="mx-3 text-muted fw-bold">Daños</span>
                                    <div className="flex-grow-1 border-top"></div>
                                </div>
                                {recepcionFromApi.danos && recepcionFromApi.danos.length > 0 ? recepcionFromApi.danos.map((dano, index) => (
                                    <div key={index} className="border p-2 mb-2">
                                        <div className="row">
                                            <div className="col-6">
                                                <strong>Tipo:</strong> {dano.tipo || 'N/A'}
                                            </div>
                                            <div className="col-6">
                                                <strong>Parte:</strong> {dano.parte || 'N/A'}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <strong>Descripción:</strong> {dano.descripcion || 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                )) : <></>}
                            </> : <></>}

                            <div className="row">
                                <div className="col-6">
                                    <Label for="sucio">Vehículo sucio</Label>
                                </div>
                                <div className="col-6">
                                    <Input
                                        type="checkbox"
                                        id="sucio"
                                        name="sucio"
                                        checked={recepcionFromApi.sucio_chk}
                                        disabled
                                    />
                                </div>
                            </div>

                            {/* Imágenes */}
                            {recepcionFromApi.imagenes && recepcionFromApi.imagenes.length > 0 && (
                                <>
                                    <div className="d-flex align-items-center my-2">
                                        <div className="flex-grow-1 border-top"></div>
                                        <span className="mx-3 text-muted fw-bold">Imágenes</span>
                                        <div className="flex-grow-1 border-top"></div>
                                    </div>
                                    <div className="row">
                                        {recepcionFromApi.imagenes.map((imagen, index) => (
                                            <div key={index} className="col-6 col-md-4 mb-3">
                                                <img
                                                    src={`https://img-records.siga-ltda.click/records/${imagen.record_uuid}`}
                                                    alt={`Imagen ${index + 1}`}
                                                    className="img-fluid rounded"
                                                    style={{ maxHeight: '150px', objectFit: 'cover' }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="cliente">Cliente</Label>
                                        <Input
                                            type="text"
                                            id="contacto"
                                            name="contacto"
                                            value={recepcionFromApi.contacto || recepcionFromApi.clipro || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="nombre_recepcionista">Recepcionista</Label>
                                        <Input
                                            type="text"
                                            id="nombre_recepcionista"
                                            name="nombre_recepcionista"
                                            value={recepcionFromApi.nombre2_firma || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            {recepcionFromApi.firmas && recepcionFromApi.firmas[0] && (

                                <div className="row">
                                    {recepcionFromApi.firmas[0].firma_cliente && (
                                        <div className="col-6">
                                            <FormGroup>
                                                <Label>Firma cliente</Label>
                                                <img
                                                    src={recepcionFromApi.firmas[0].firma_cliente}
                                                    alt="Firma cliente"
                                                    className="img-fluid border d-block"
                                                    style={{ maxHeight: '100px' }}
                                                />
                                            </FormGroup>
                                        </div>
                                    )}
                                    {recepcionFromApi.firmas[0].firma_recepcionista && (
                                        <div className="col-6">
                                            <FormGroup>
                                                <Label>Firma recepcionista</Label>
                                                <img
                                                    src={recepcionFromApi.firmas[0].firma_recepcionista}
                                                    alt="Firma recepcionista"
                                                    className="img-fluid border d-block"
                                                    style={{ maxHeight: '100px' }}
                                                />
                                            </FormGroup>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="select_quien_retira">Quien retira?</Label>
                                        <Input
                                            type="text"
                                            id="quien_retira"
                                            name="quien_retira"
                                            value={recepcionFromApi.quien_retira || 'N/A'}
                                            disabled
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </>
                    ) : null}
                </Form>
                {errorPdf && (
                    <Alert color="danger" className="mt-3">
                        <i className="ri-error-warning-line me-2"></i>
                        {errorPdf}
                    </Alert>
                )}
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-primary me-2" onClick={handleDownloadPdf} disabled={loadingPdf || !recepcionFromApi}>
                    {loadingPdf ? (
                        <>
                            <Spinner size="sm" className="me-1" />
                            Cargando...
                        </>
                    ) : (
                        <>
                            <i className="ri-file-pdf-line me-1"></i>
                            Ver PDF
                        </>
                    )}
                </button>
                <button type="button" className="btn btn-secondary" onClick={toggle}>
                    Cerrar
                </button>
            </ModalFooter>
        </Modal >
    );
};

export default ModalLeerRecepcionVehiculo;